import React, { useEffect, useState } from "react";
import axios from "../API/axios";
import { t } from "i18next";

/**
 * Suggests skills from similar live jobs + title tokens for the selected industry.
 */
export default function SkillSuggestChips({ title, fitid, selected = [], onAdd }) {
  const sessionId = localStorage.getItem("sessionId");
  const [items, setItems] = useState([]);

  useEffect(() => {
    const text = (title || "").trim();
    if (text.length < 2 || !fitid) {
      setItems([]);
      return undefined;
    }
    const timer = setTimeout(() => {
      axios
        .post("Master/SuggestSkills", {
          deviceType: "Web",
          sessionId,
          title: text,
          fitid,
          take: 8,
        })
        .then((res) => {
          const data = res.data?.responseData;
          setItems(Array.isArray(data) ? data : []);
        })
        .catch(() => setItems([]));
    }, 400);
    return () => clearTimeout(timer);
  }, [title, fitid, sessionId]);

  const selectedIds = new Set(
    (selected || []).map((s) => String(s.value ?? s.skllId ?? s.id ?? ""))
  );
  const selectedNames = new Set(
    (selected || []).map((s) => String(s.label || s.name || "").toLowerCase())
  );
  const visible = items.filter((item) => {
    const id = String(item.skllId ?? item.SkllId ?? item.id ?? "");
    const name = String(item.name || item.Name || "").toLowerCase();
    return (!id || !selectedIds.has(id)) && !selectedNames.has(name);
  });

  if (!visible.length) return null;

  return (
    <div className="wlj-suggest-row">
      <span className="wlj-suggest-label">{t("Recruiter.Suggested")}</span>
      {visible.map((item) => {
        const id = item.skllId ?? item.SkllId ?? item.id;
        const name = item.name || item.Name;
        return (
          <button
            key={id || name}
            type="button"
            className="wlj-suggest-chip"
            onClick={() => onAdd?.({ value: id, label: name })}
          >
            + {name}
          </button>
        );
      })}
    </div>
  );
}
